import React, { useCallback, useEffect, useState } from 'react';
import { getProPrefixCls } from 'choerodon-ui/lib/configure';
import { Size } from 'choerodon-ui/lib/_util/enum';
import Button from '../button/Button';
import { FuncType } from '../button/enum';
import Picture from './Picture';
const PictureViewer = function PictureViewer(props) {
    const { list, defaultIndex = 0, prefixCls, modal } = props;
    const [index, setIndex] = useState(defaultIndex);
    const customizedPrefixCls = getProPrefixCls('picture-viewer', prefixCls);
    const handlePrev = useCallback(() => setIndex(index - 1), [index]);
    const handleNext = useCallback(() => setIndex(index + 1), [index]);
    const { length } = list;
    useEffect(() => {
        if (modal) {
            modal.update({
                header(title, closeBtn) {
                    return (React.createElement("div", { className: `${customizedPrefixCls}-header` },
                        React.createElement("span", null, title),
                        length > 1 ? React.createElement("span", null,
                            index + 1,
                            " / ",
                            length) : undefined,
                        closeBtn));
                },
            });
        }
    }, [index, length, customizedPrefixCls]);
    if (length) {
        const src = list[index];
        return (React.createElement("div", { className: customizedPrefixCls },
            length > 1 && (React.createElement(Button, { icon: "navigate_before", disabled: index === 0, funcType: FuncType.link, onClick: handlePrev, className: `${customizedPrefixCls}-btn`, size: Size.large })),
            React.createElement("div", { className: `${customizedPrefixCls}-picture` },
                React.createElement(Picture, { src: src, objectFit: "scale-down", status: "loaded", preview: false, lazy: false })),
            length > 1 && (React.createElement(Button, { icon: "navigate_next", disabled: index === length - 1, funcType: FuncType.link, onClick: handleNext, className: `${customizedPrefixCls}-btn`, size: Size.large }))));
    }
    return null;
};
PictureViewer.displayName = 'PictureViewer';
export default PictureViewer;
